import React, { useEffect } from 'react'
import { useLocation, useParams } from 'react-router-dom'
import { TURN_OS_VACANCIES_URL } from 'lib/turn-os'

export const retiredConstructionDestination = (pathname: string, vendorId?: string) => {
  if (pathname.startsWith('/construction/tickets')) return 'https://turn-os.upandup.co/tickets'
  if (pathname.startsWith('/construction/occupancy_inspections'))
    return 'https://turn-os.upandup.co/home-inspections'
  if (pathname.startsWith('/construction/vendors'))
    return `https://turn-os.upandup.co/vendors${
      vendorId ? `?vendor_id=${encodeURIComponent(vendorId)}` : ''
    }`
  if (pathname.startsWith('/construction/home-systems')) return '/homes'
  if (pathname.startsWith('/construction/latchel-sync-manager'))
    return 'https://turn-os.upandup.co/tickets'
  return TURN_OS_VACANCIES_URL
}

export default function RetiredConstructionRedirect() {
  const { pathname } = useLocation()
  const { vendorId } = useParams<{ vendorId?: string }>()
  const destination = retiredConstructionDestination(pathname, vendorId)
  useEffect(() => {
    window.location.replace(destination)
  }, [destination])
  return <p>Opening the current workspace…</p>
}
